import React from 'react';

const EyeIcon = ({ isVisible, onClick }) => {
    return (
        <span className="password-toggle" onClick={onClick}>
            {isVisible ? (
                <svg viewBox="0 0 24 24">
                    <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" />
                </svg>
            ) : (
                <svg viewBox="0 0 24 24">
                    <path d="M2.45703 12C3.73128 7.94291 7.52159 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C20.2672 16.0571 16.4769 19 11.9992 19C7.52159 19 3.73128 16.0571 2.45703 12Z" />
                    <circle cx="12" cy="12" r="3" />
                </svg>
            )}
        </span>
    );
};

export default EyeIcon;
